import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface HeaderTitlesProps {
  visible: boolean;
  title: string;
  subtitle: string;
}

const HeaderTitlesComponent: React.FC<HeaderTitlesProps> = ({
  visible,
  title,
  subtitle,
}) => {
  return (
    <div className={`peptalk-chat-header-titles ${visible ? 'visible' : ''}`}>
      <span className="peptalk-chat-header-title">{title}</span>
      <span className="peptalk-chat-header-subtitle">{subtitle}</span>
    </div>
  );
};

export const HeaderTitles: React.FC<HeaderTitlesProps> = (
  props: HeaderTitlesProps
) => {
  const Component = useCustomComponent({
    componentName: 'HeaderTitles',
    Component: HeaderTitlesComponent,
  });
  return <Component {...props} />;
};
